import { CircularProgress, InputAdornment, TextField } from "@material-ui/core";
import { ChangeEventHandler, useEffect, useRef } from "react";

interface Props {
  className: string;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  loading?: boolean;
}

export const DriverBreadcrumbSearchField = ({
  className,
  value,
  onChange,
  loading,
}: Props) => {
  const searchRef = useRef<HTMLInputElement>(null);
  const focused = useRef<boolean>(false);

  useEffect(() => {
    if (!searchRef.current) {
      return;
    }

    if (focused.current) {
      return;
    }

    searchRef.current.focus();
    focused.current = true;
  });

  return (
    <TextField
      inputRef={searchRef}
      className={className}
      label="Search"
      variant="outlined"
      margin="dense"
      value={value}
      onChange={onChange}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {loading && (
              <CircularProgress style={{ width: "32px", height: "32px" }} />
            )}
          </InputAdornment>
        ),
      }}
    ></TextField>
  );
};
